import { render, staticRenderFns } from "./kbjiDetail.vue?vue&type=template&id=a0f92cf0"
import script from "./kbjiDetail.vue?vue&type=script&lang=js"
export * from "./kbjiDetail.vue?vue&type=script&lang=js"
import style0 from "./kbjiDetail.vue?vue&type=style&index=0&id=a0f92cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports